export default __webpack_public_path__ + "static/media/Group5.99eeb439.svg";